import { interval } from "rxjs";
import { filter, first, map } from "rxjs/operators";

const sessionIdKey = "sessionId";
const deviceIdKey = "device-id";

export const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
export const sessionId = generateUUID();
const cachedDeviceId = localStorage.getItem(deviceIdKey);
export const deviceId = cachedDeviceId || generateUUID();
sessionStorage.setItem(sessionIdKey, sessionId);
localStorage.setItem(deviceIdKey, deviceId);

export const onAppLoaded = () => {
    return interval(20)
        .pipe(
            map((x) => document.getElementById("app")),
            filter((x) => x != null),
            first()
        )
        .toPromise();
};
